module.exports = "/add_neighbour-d9d3472bd813d95f0d37f2dd568467f5.svg";